<object id="pdfObject" type="application/pdf" class="pdf-viewer">
   <iframe id='pdfIFrame' type="application/pdf"></iframe>
</object>
